import axios from 'axios';
import type { AxiosResponse } from 'axios';
import Locals from '../providers/Locals';
import { requestInterceptor, requestErrorInterceptor, responseErrorInterceptor } from './config';

const API_BASE_URL = Locals.config().base_api_url;

const apiV2 = axios.create({
    baseURL: API_BASE_URL + '/api/v2',
    headers: {
        'Content-Type': 'application/json'
    }
});

const apiV2ResponseInterceptor = (response: AxiosResponse): AxiosResponse | Promise<never> => {
    if (response.status === 204) return response;

    const body = response.data;
    if (body && typeof body === 'object' && 'success' in body) {
        if (body.success === true) {
            return { ...response, data: body.data };
        }
        if (body.success === false) {
            const message = body.error?.message ?? 'API error';
            return Promise.reject(new Error(message));
        }
    }

    return response;
};

apiV2.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
apiV2.interceptors.response.use(apiV2ResponseInterceptor, responseErrorInterceptor);

export default apiV2;
